import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class MessageMenu extends Model {
    static entity = 'message-menu';

    static includes = [];

    static queryBuilder = new QueryBuilder(this.entity);

    static fields() {
        return {
            data: this.attr(null),
            all: this.attr(null),
            items: this.attr(null),
            title: this.attr(null),
            type: this.attr(null),
        };
    }

    static fetchOne(slug) {
        const queryBuilder = new QueryBuilder(`${this.entity}/${slug}`);

        const url = queryBuilder.include(['tags', 'groups', 'media']).toUrl();

        return this.api().get(url);
    }

    static async create(model) {
        if (!model.order) {
            model.order = 1;
        }
        return this.api().post(this.queryBuilder.toUrl(), model);
    }

    static async update(model) {}
}
